import { render, staticRenderFns } from "./TradeToDosList.vue?vue&type=template&id=1a951e22&scoped=true&"
import script from "./TradeToDosList.vue?vue&type=script&lang=ts&"
export * from "./TradeToDosList.vue?vue&type=script&lang=ts&"
import style0 from "./TradeToDosList.vue?vue&type=style&index=0&id=1a951e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a951e22",
  null
  
)

export default component.exports